import React from "react";
import { motion } from "framer-motion";
import Footer from "../Base/Footer";
import Navbar from "./components/Navbar";

import fallbackImg1 from "../assets/img/event-images/2.jpeg";
import fallbackImg2 from "../assets/img/event-images/3.jpeg";
import fallbackImg3 from "../assets/img/event-images/5.jpeg";

const user = {
  name: "Lauren Olivier",
  accountType: "EXECUTIVE",
  avatarUrl: "https://i.ibb.co/xqnrW3cK/woman-pfp.jpg",
  hasNotifications: true,
};

const portalPageStaggerVariants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      duration: 0.28,
      ease: [0.22, 1, 0.36, 1],
      staggerChildren: 0.08,
      delayChildren: 0.03,
    },
  },
};

const portalFadeUpVariants = {
  hidden: { opacity: 0, y: 16 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.34, ease: [0.22, 1, 0.36, 1] },
  },
};

const aboutSections = [
  {
    title: "Philanthropy",
    body:
      "For philanthropy, Apollo provides all employees with an annual Citizenship Grant which can be used for matching gifts and volunteer rewards. These initiatives enable Apollo to join our employees in supporting the communities in which they live, and the institutions and organizations of greatest importance to them.",
    image:
      process.env.PUBLIC_URL +
      "/images/apollo/about/250626-nyc-engineering-bbpc_3.jpg",
    fallback: fallbackImg1,
    alt: "Apollo team members collaborating",
  },
  {
    title: "Volunteerism",
    body:
      "For volunteerism, Apollo is proud to empower our employees to give back in our communities around the globe. In 2025, Apollo hosted 350+ volunteer opportunities for employees to get involved, resulting in over 17,280+ hours of service. Citizenship has also organized Apollo Community Together (ACT) Teams around the world; ACT Teams are groups of employee volunteers in regional offices who champion local Citizenship activities.",
    image:
      process.env.PUBLIC_URL +
      "/images/apollo/about/250724-london-es-london-play-design-group-photo_2.jpg",
    fallback: fallbackImg2,
    alt: "Apollo volunteers in community service",
  },
  {
    title: "Board Engagement and Leadership",
    body:
      "For other forms of engagement, Citizenship encourages employees to serve on non-profit boards and junior boards, and hosts board service conversations, training and placement programs. Citizenship also offers a $5,000 board bonus matching gift for employees who serve on non-profit boards. This Apollo Purpose Portal is an extension of that work.",
    image: fallbackImg2,
    fallback: fallbackImg2,
    alt: "Leadership discussion and board service planning",
  },
];

function AboutSectionImage({ src, fallback, alt }) {
  return (
    <img
      className="about-page__section-image"
      src={src}
      alt={alt}
      loading="lazy"
      onError={(event) => {
        event.currentTarget.onerror = null;
        event.currentTarget.src = fallback;
      }}
    />
  );
}

export default function About() {
  const citizenshipLogo =
    process.env.PUBLIC_URL + "/images/apollo/apollo-citizenship-logo.png";
  const bottomImage =
    process.env.PUBLIC_URL + "/images/apollo/about/202201-partner-summit_aof-launch-1.jpg";

  return (
    <div className="ed-wrapper">
      <motion.div
        className="ed-main"
        initial="hidden"
        animate="show"
        variants={portalPageStaggerVariants}
      >
        <Navbar user={user} currentPage="about" />

        <motion.section className="hero-board bg-2" variants={portalFadeUpVariants}>
          <div className="hero-board__overlay" />
          <div className="hero-board__content">
            <h1 className="hero-board__title">About</h1>
            <p className="hero-board__subtitle">
              A dedicated platform to engage Apollo employees in meaningful and
              impactful Citizenship programs.
            </p>
          </div>
        </motion.section>

        <motion.section className="about-page" variants={portalFadeUpVariants}>
          <div className="about-page__intro">
            <div className="about-page__intro-text">
              <h2 className="about-page__title">Apollo Citizenship</h2>
              <p className="about-page__lead">
                Apollo is committed to investing in its communities and engaging
                its employees and other stakeholders in meaningful and impactful
                Citizenship Programs. Apollo Citizenship offers philanthropic,
                volunteer, and other forms of engagement to strengthen
                communities and expand opportunity around the globe.
              </p>
            </div>
            <div className="about-page__intro-logo-wrap">
              <img
                className="about-page__intro-logo"
                src={citizenshipLogo}
                alt="Apollo Citizenship logo"
              />
            </div>
          </div>

          <div className="about-page__sections">
            {aboutSections.map((section, index) => (
              <article
                key={section.title}
                className={`about-page__section ${
                  index % 2 === 1 ? "about-page__section--reverse" : ""
                }`}
              >
                <div className="about-page__section-copy">
                  <h3 className="about-page__section-title">{section.title}</h3>
                  <p className="about-page__section-text">{section.body}</p>
                </div>
                <div className="about-page__section-media">
                  <AboutSectionImage
                    src={section.image}
                    fallback={section.fallback}
                    alt={section.alt}
                  />
                </div>
              </article>
            ))}
          </div>

          <div className="about-page__bottom-image-wrap">
            <AboutSectionImage
              src={bottomImage}
              fallback={fallbackImg3}
              alt="Apollo team gathering at partner summit"
            />
            <p className="about-page__bottom-caption">
              Apollo Opportunity Foundation (AOF) Partner Summit launch, 2022
            </p>
          </div>
        </motion.section>

        <div className="ed-footer">
          <Footer alternate={true} />
        </div>
      </motion.div>
    </div>
  );
}
